import React from "react";
import BaseDetailPage from "../../_CustomComponents/BaseDetailPage";
import ReactToPrint from "react-to-print";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import * as forecastBatchCrud from "../../../../crud/forecastBatch.crud";
import axios from "axios";
import ForecastBatchDocument from "./Document";
import { Navigate } from "react-router-dom";
import { TabPanel, Item } from "devextreme-react/tab-panel";
import PageToolbar from '../../_CustomComponents/PageToolbar';
import { withDetailPageProps } from '../../../../shared/hoc/withDetailPageProps';
import NavigationBlocker from '../../../../partials/Tools/NavigationBlocker';
import EmailNotifications from "../../_CustomComponents/EmailNotifications";
//import NotificationContext from '../../../../../notificationContext';
import ProjectOrderBatchModal from "./ProjectOrderBatchModal/ProjectOrderBatchModal";

const initialState = {
  notification: null,
  saving: false,
  isChanged: false,
  postActionUrl: null,
  showWizard: false
};

class ForecastBatchDetailPage extends BaseDetailPage {
  constructor(props) {
    super(props);
    this.printNotificationDivRef = React.createRef();
    this.state = { ...initialState };

    this.multipleProjectOrderWizardEnabled =
            process.env.REACT_APP_COSTFORECAST_BATCH_ENABLED === 'true'
            && props.workflowItem.userFilters.mainNotice.createAllowed;
  }

  //static contextType = NotificationContext;

  componentDidMount() {
    this.fetchForecastBatch();
  }

  // componentWillUnmount() {
  //     this.context.updateNotificationContext({
  //         documentIsFinal: false,
  //         path: null,
  //         referenceId: null,
  //         referenceType: null,
  //         workflowGroupId: null,
  //         workflowId: null,
  //     });
  // }

  componentDidUpdate(prevprops, prevSatate) {
    if (
      this.props.params.batchid !==
      prevprops.params.batchid
    ) {
      this.setState({ ...initialState }, () => {
        this.fetchForecastBatch();
      });
    }
  }

  getSelectedTypeClauseDisplay = () => {
    return "";
  }
  fetchForecastBatch = async () => {
    try {
      await this.props.closeSnackbar("PersistentFormWarning");
      const { data: forecastBatch } = await forecastBatchCrud.get(this.props.params.batchid);
      if (
        forecastBatch.contractid !== this.props.contract.contractid ||
        forecastBatch.notificationtype !== this.props.workflowItem.config.currentModelType
      ) {
        throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.INVALID_URL' }));
      }


      this.setState({
        notification: forecastBatch,
        showWizard: !forecastBatch.communicated,
        saving: false,
        isChanged: false,
      }, () => { 
        this.props.setReference(this.state.notification.referenceid);
        // this.context.updateNotificationContext({
        //     documentIsFinal: forecastBatch.showtasknotification === 1,
        //     path: this.props.location.pathname,
        //     referenceId: this.props.params.notificationid,
        //     referenceType: this.props.workflowItem.config.referenceType,
        //     workflowGroupId: this.props.workflowGroupItem.id,
        //     workflowId: this.props.workflowItem.id,
        // });
      });
    }
    catch (err) {
      if (!axios.isCancel(err)) {
        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
      }
    }
  };

  printHandler = () => {
    this.printRef.handlePrint();
  };


  renderToolbar = () => {
    const saveDisabled = (this.state.saving || this.state.showModal || this.state.fileUploading);
    return (
      <PageToolbar
        key={this.state.notification.version}
        documentIsFinal={true}
        saveDisabled={saveDisabled}
        actions={{
          onPrint: this.printHandler
        }}
        workflowItem={this.props.workflowItem}
        match={this.props.match}
        referenceid={this.state.notification.referenceid}
        contract={this.props.contract}
        notification={this.state.notification}
        selectedClausetypeDisplay={this.getSelectedTypeClauseDisplay()}
      />
    );
  };

  tabDocument = () => {
    return (
      <ForecastBatchDocument
        {...this.props}
        printDivRef={this.printNotificationDivRef}
        fieldChanged={this.fieldChanged}
        notification={this.state.notification}
        files={this.state.files}

        onFilesCountChanged={(fCount) => { if (this.state.fileCount !== fCount) { this.setState({ fileCount: fCount }) } }}
        batchid={this.props.params.batchid}
        saving={this.state.saving}
        onFileUploadFinish={() => this.setState({ fileUploading: false })}
        onFileUploadStart={() => this.setState({ fileUploading: true })}
      />
    );
  };


  tabEmailNotification = () => {
    return (
      <EmailNotifications
        {...this.props}
        notificationDate={this.state.notification.communicateddate}
      />
    );
  };

  onProjectOrderBatchClosed = () => {
      this.setState({ showWizard: false }, () => {
          //this.loadForecastBatches();
      });
  }

  render() {
    if (!this.state.notification) {
      return <PortletSpinner />;
    }

    if (this.multipleProjectOrderWizardEnabled && !this.state.notification.communicated) {
      return (
        <ProjectOrderBatchModal
          {...this.props}
          visible={this.state.showWizard}
          onClose={this.onProjectOrderBatchClosed}
          forecastBatchId={this.state.notification.forecastbatchid}
        />
      );
    }

    return (
      <Portlet>
        <ReactToPrint
          ref={(el) => (this.printRef = el)}
          trigger={() => <div style={{ display: "none" }}></div>}
          content={() => this.printNotificationDivRef.current}
        />
        <NavigationBlocker
          when={(this.state.isChanged || this.state.saving)}
          message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' })}
        />
        {this.state.navigateto &&
          (
            <Navigate replace to={this.state.navigateto} state={(this.state.postActionUrl || {}).state} />
          )
        }
        <PortletHeader
          title={this.props.workflowItem.pageTitle}
          toolbar={this.renderToolbar()}
        />
        <PortletBody>
          <TabPanel
            width="100%"
            deferRendering={false}
            animationEnabled={true}
            focusStateEnabled={true}
            hoverStateEnabled={true}
            swipeEnabled={false}
          >
            <Item
              icon="file"
              title={this.props.title}
              render={this.tabDocument}
            />
            <Item
              icon="bulletlist"
              title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_EMAIL_NOTIFICATIONS' })}
              render={this.tabEmailNotification}
            />
          </TabPanel>
        </PortletBody>
      </Portlet>
    );
  }
}


export default withDetailPageProps(ForecastBatchDetailPage);